export function isOriginalRinkSku(rinkSku) {
  return rinkSku.includes('RINK')
}

export function getOrgRinkWidth(orgRinkSku) {
  return orgRinkSku.substring(2, 5)
}
export function getOrgRinkLength(orgRinkSku) {
  return orgRinkSku.substring(6, 9)
}
export function getOrgRinkStyles(orgRinkSku) {
  return 'CCC'
}
export function getOrgRinkFeatures(orgRinkSku) {
  return `${orgRinkSku.substring(20, 24) == 'RNDD' ? 'R' : 'S'}XX`
}

export function getProRinkWidth(proRinkSku) {
  return proRinkSku.substring(0, 3)
}
export function getProRinkLength(proRinkSku) {
  return proRinkSku.substring(3, 6)
}
export function getProRinkStyles(proRinkSku) {
  return proRinkSku.substring(6, 9)
}
export function getProRinkFeatures(proRinkSku) {
  return proRinkSku.substring(9, 12)
}
export function getProRinkCorner(proRinkSku) {
  return proRinkSku.substring(9, 10)
}
export function getProRinkBumper(proRinkSku) {
  return proRinkSku.substring(10, 11)
}


export function humanizeSides(left, middle, right) {
  return `${humanizeSide(left)}-${humanizeSide(middle)}-${humanizeSide(right)}`;
}

export function humanizeSide(letter) {
  if (letter == 'C') {
    return 'Classic';
  } else if (letter == 'D') {
    return 'Double';
  } else if (letter == 'A') {
    return 'Arena';
  } else if (letter == 'N') {
    return 'Net';
  }
}

export function getProRinkNameFromSku(sku) {
  const width = parseInt(getProRinkWidth(sku))
  const length = parseInt(getProRinkLength(sku))

  const style = getProRinkStyles(sku)
  const styleLeft = style[0]
  const styleMiddle = style[1]
  const styleRight = style[2]

  const features = getProRinkFeatures(sku)
  const corners = features[0]
  const bumpers = features[1]

  return `EZ ICE PRO Home Arena System ™ – New Rink: [PRO // ${width}ft * ${length}ft // ${humanizeSides(styleLeft, styleMiddle, styleRight)} // ${corners == 'S' ? 'Square' : 'Round'} Corners // ${bumpers == 'B' ? 'With' : 'No'} Bumpers]`
}

export function getWupUpgradeNameFromSkus(oldSku, newSku) {
  const isOriginalUpgrade = isOriginalRinkSku(oldSku);

  const oldWidth = isOriginalUpgrade ? getOrgRinkWidth(oldSku) : getProRinkWidth(oldSku)
  const oldLength = isOriginalUpgrade ? getOrgRinkLength(oldSku) : getProRinkLength(oldSku)
  const oldStyle = isOriginalUpgrade ? getOrgRinkStyles(oldSku) : getProRinkStyles(oldSku)
  const oldFeatures = isOriginalUpgrade ? getOrgRinkFeatures(oldSku) : getProRinkFeatures(oldSku)

  const newWidth = getProRinkWidth(newSku)
  const newLength = getProRinkLength(newSku)
  const newStyle = getProRinkStyles(newSku)
  const newFeatures = getProRinkFeatures(newSku)

  return `EZ ICE PRO Home Arena System ™ – Upgrade from [${isOriginalRinkSku(oldSku) ? 'ORG' : 'PRO'} // ${parseInt(oldWidth)}ft * ${parseInt(oldLength)}ft // ${humanizeSides(oldStyle[0], oldStyle[1], oldStyle[2])} // ${oldFeatures[0] == 'S' ? 'Square' : 'Round'} Corners // ${oldFeatures[1] == 'B' ? 'With' : 'No'} Bumpers] to [PRO // ${parseInt(newWidth)}ft * ${parseInt(newLength)}ft // ${humanizeSides(newStyle[0], newStyle[1], newStyle[2])} // ${newFeatures[0] == 'S' ? 'Square' : 'Round'} Corners // ${newFeatures[1] == 'B' ? 'With' : 'No'} Bumpers]`
}

export function getNearestRinkSizeFromWidth(width) {
  if (width >= 10 && width <= 15) {
    return { width: 15, length: 30 };
  } else if (width > 15 && width <= 20) {
    return { width: 20, length: 40 };
  } else if (width > 20 && width <= 25) {
    return { width: 25, length: 50 };
  } else if (width > 25 && width <= 30) {
    return { width: 30, length: 60 };
  } else if (width > 30 && width <= 40) {
    return { width: 40, length: 80 };
  } else if (width > 40 && width <= 60) {
    return { width: 60, length: 100 };
  } else if (width > 60 && width <= 80) {
    return { width: 80, length: 120 };
  } else if (width > 80) {
    return { width: 85, length: 200 };
  }
}

export function generateRinkImageStyle(styleString) {
  let style;
  if (styleString == 'CCC') {
    style = '01';
  } else if (styleString == 'DDD') {
    style = '02';
  } else if (styleString == 'AAA') {
    style = '03';
  } else if (styleString == 'NNN') {
    style = '04';
  } else if (styleString == 'NCN') {
    style = '05';
  } else if (styleString == 'ACA') {
    style = '06';
  } else if (styleString == 'DCD') {
    style = '07';
  } else if (styleString == 'ADA') {
    style = '08';
  } else if (styleString == 'NDN') {
    style = '09';
  } else if (styleString == 'CCN') {
    style = '10';
  } else if (styleString == 'CCA') {
    style = '11';
  } else if (styleString == 'CCD') {
    style = '12';
  } else if (styleString == 'DDA') {
    style = '13';
  } else if (styleString == 'DDN') {
    style = '14';
  } else if (styleString == 'NCC') {
    style = '15';
  } else if (styleString == 'ACC') {
    style = '16';
  } else if (styleString == 'DCC') {
    style = '17';
  } else if (styleString == 'ADD') {
    style = '18';
  } else if (styleString == 'NDD') {
    style = '19';
  } else if (styleString == 'NAN') {
    style = '20';
  } else if (styleString == 'AAN') {
    style = '21';
  } else if (styleString == 'NAA') {
    style = '22';
  } else if (styleString == 'DCA') {
    style = '23';
  } else if (styleString == 'DCN') {
    style = '24';
  } else if (styleString == 'ACN') {
    style = '25';
  } else if (styleString == 'ACD') {
    style = '26';
  } else if (styleString == 'NCD') {
    style = '27';
  } else if (styleString == 'NCA') {
    style = '28';
  } else if (styleString == 'NDA') {
    style = '29';
  } else if (styleString == 'ADN') {
    style = '30';
  }

  return style;
}

export function generateImageUrlFromNormalizedSku(sku) {
  const rinkSize = getNearestRinkSizeFromWidth(getProRinkWidth(sku));
  const corners = getProRinkCorner(sku);
  const bumpers = getProRinkBumper(sku);

  return `https://ezice.s3.amazonaws.com/rink-calc/imgc/${rinkSize.width}x${rinkSize.length}_${corners}_${bumpers == 'B' ? 'Y' : 'N'}_Y_${generateRinkImageStyle(getProRinkStyles(sku))}.jpg`;
}
